import { HoardingGroupDialogComponent } from "./hoarding-group-dialog.component";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { ButtonModule, SharedModule, InputTextModule, AutoCompleteModule, DropdownModule, CalendarModule, TooltipModule, DialogModule, TreeTableModule } from "primeng/primeng";
import { InputTrimModule } from "../../../directives/input-trim";
import { CommonTreeTableModule } from "../treeTable/tree-table.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        HttpModule,
        ButtonModule,
        SharedModule,
        InputTextModule,
        AutoCompleteModule,
        DropdownModule,
        CalendarModule,
        TooltipModule,
        InputTrimModule,
        DialogModule,
        TreeTableModule,
        CommonTreeTableModule
    ],

    declarations: [
        HoardingGroupDialogComponent
    ],

    exports: [
        HoardingGroupDialogComponent
    ],
    providers: []
})

export class HoardingGroupDialogModule { }